import {useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {resetPassword} from '../../api/authApi';
import {defaultAlert} from "../../utils/alert";
import {validatePassword} from "../../utils/validation";
import axios from 'axios';

const ResetPasswordPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [isPasswordMatching, setIsPasswordMatching] = useState(false);
    const [isPasswordValid, setIsPasswordValid] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    // 인증되지 않으면 이전 페이지로
    if (!location.state?.verified) {
        navigate('/find-password');
        return null;
    }

    const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const pwd = e.target.value;
        setNewPassword(pwd);
        setIsPasswordValid(validatePassword(pwd));
        checkPasswordMatch(pwd, confirmPassword);
    };

    const handleConfirmPasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const pwd = e.target.value;
        setConfirmPassword(pwd);
        checkPasswordMatch(newPassword, pwd);
    };

    const checkPasswordMatch = (pwd: string, confirm: string) => {
        setIsPasswordMatching(pwd === confirm && pwd.length > 0 && validatePassword(pwd));
    };

    const handleResetPassword = async () => {
        if (!isPasswordValid) {
            defaultAlert('비밀번호는 영문 대소문자/숫자/특수문자 중 2가지 이상 조합, 8자~20자여야 합니다.');
            return;
        }

        if (newPassword !== confirmPassword) {
            defaultAlert('비밀번호가 일치하지 않습니다.');
            return;
        }

        try {
            setIsLoading(true);
            await resetPassword({
                memberId: location.state.memberId,
                phone: location.state.phone,
                newPassword
            });

            defaultAlert('비밀번호가 변경되었습니다.');
            navigate('/login');
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const message = error.response?.data?.message || '비밀번호 변경에 실패했습니다.';
                defaultAlert(message);
            } else {
                defaultAlert('비밀번호 변경에 실패했습니다.');
            }
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="page-wrapper">
            <header className="sub-header">
                <div className="header-inner">
                    <button type="button" className="backBtn" onClick={() => navigate(-1)}>
                        <span className="blind">뒤로가기</span>
                    </button>
                </div>
            </header>

            <div className="bottom-btn">
                <button
                    type="button"
                    className="btn confirm"
                    onClick={handleResetPassword}
                    disabled={!isPasswordMatching || isLoading}
                >
                    {isLoading ? '처리 중...' : '저장'}
                </button>
            </div>

            <main className="container">
                <section className="tit-box-wrap">
                    <h2 className="headline">새 비밀번호 설정</h2>
                    <p className="subtit">정보보호를 위해 새 비밀번호를 입력해 주세요</p>
                </section>

                <section>
                    <div className="inner-box">
                        <form>
                            <fieldset>
                                <legend>새로운 비밀번호 설정 폼</legend>
                                <div className="form-box">
                                    <div className="form-item">
                                        <label className="input-tit">새로운 비밀번호를 입력하세요</label>
                                        <div className="input-box">
                                            <input
                                                type="password"
                                                placeholder="비밀번호 설정(영문 대소문자/숫자/특수문자 중 2가지 이상 8자~20자)"
                                                value={newPassword}
                                                onChange={handlePasswordChange}
                                            />
                                        </div>
                                        {newPassword && !isPasswordValid && (
                                            <p className="error-msg">비밀번호는 영문 대소문자/숫자/특수문자 중 2가지 이상 조합, 8자~20자</p>
                                        )}
                                        {newPassword && isPasswordValid && (
                                            <p className="success-msg">유효한 비밀번호입니다.</p>
                                        )}
                                    </div>

                                    <div className="form-item">
                                        <label className="input-tit">새 비밀번호를 재입력하세요</label>
                                        <div className="input-box">
                                            <input
                                                type="password"
                                                placeholder="비밀번호 재확인"
                                                value={confirmPassword}
                                                onChange={handleConfirmPasswordChange}
                                            />
                                        </div>
                                        {confirmPassword && !isPasswordMatching && (
                                            <p className="error-msg">비밀번호가 일치하지 않습니다.</p>
                                        )}
                                    </div>
                                </div>
                            </fieldset>
                        </form>
                    </div>
                </section>
            </main>
        </div>
    );
};

export default ResetPasswordPage;